import React from 'react'
import ReactModal from 'react-modal'

function ProfessionalAccountUpdatesModal({uploadNew, onClose, onSubmit}) {
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
          zIndex: 55,
          backgroundColor: 'rgba(20,33,61,.4)'
        },
        content: {
            zIndex: 55,
            height: 'auto',
            width: 'auto',
            maxWidth: '420px',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: '30px 32px',
            border: '1px solid rgba(20,33,61,.14)',
            borderRadius: '4px',
            backgroundColor: '#fffdf8',
            boxShadow: '0 12px 32px rgba(20,33,61,.3)',
        }
      }}
    >
        <div className='flex items-center flex-col text-center font-plexsans'>
            <div style={{font:"400 17px/1.4 'Spectral',serif", color:'#14213d', marginBottom:'8px'}}>Start a new edit?</div>
            <div style={{font:"400 13px/1.6 'IBM Plex Sans',sans-serif", color:'rgba(20,33,61,.55)'}}>
              You're editing before your last submission was approved, so those pending changes will be discarded and replaced with this new edit.
            </div>
            <div className='flex gap-2.5 w-full mt-6 justify-center'>
                <div
                className="text-center cursor-pointer rounded-sm whitespace-nowrap"
                style={{font:"500 13px/1 'IBM Plex Sans',sans-serif", color:'rgba(20,33,61,.6)', border:'1px solid rgba(20,33,61,.2)', padding:'12px 20px'}}
                onClick={onClose}>Back</div>
                <div
                className="text-center cursor-pointer rounded-sm whitespace-nowrap"
                style={{font:"500 13px/1 'IBM Plex Sans',sans-serif", color:'#fffdf8', background:'#8a6231', border:'none', padding:'12px 20px'}}
                onClick={onSubmit}>Make a new edit</div>
            </div>
         </div>
    </ReactModal>
  )
}


export default ProfessionalAccountUpdatesModal
